/// <amd-module name="Feed/Common/Utils/Icons" />
import { IImageProps } from "OfficeFabric/Image";

import { IVssIconProps, VssIconType } from "VSSUI/VssIcon";

export class FabricIconProps implements IVssIconProps {
    public readonly iconType = VssIconType.fabric;

    constructor(public iconName: string) {}
}

export class BowtieIconProps implements IVssIconProps {
    public readonly iconType = VssIconType.bowtie;

    constructor(public iconName: string) {}
}

export class ImageIconProps implements IVssIconProps {
    public readonly iconType = VssIconType.image;
    public readonly imageProps: IImageProps;
    public readonly className?: string;

    constructor(iconSrcUrl: string, className?: string) {
        this.imageProps = {
            src: iconSrcUrl,
            className
        };
    }
}
